import { TeamSessionType } from '../../query/session';

export const getWholeSessionTimeSeconds = (session: TeamSessionType)=> {
  if (!session?.drills?.wholeSession?.end || !session?.drills?.wholeSession?.start) {
    return 0;
  }

  return (
    new Date(session.drills.wholeSession.end).getTime() - new Date(session.drills.wholeSession.start).getTime()
  ) / 1000;
}
